import * as React from 'react';
import { createPortal } from 'react-dom';
import { useAggreg8UserFlowWindow } from './useAggreg8UserFlowWindow';

export const Aggreg8UserFlowWindow = (props) => {
  const { container, overLayerVisible } = useAggreg8UserFlowWindow();
  return <>{container && overLayerVisible ? createPortal(props.children, container) : null}</>;
};
